export default function percent (full, partial) {
  return (partial / full) * 100
}
